module.exports = __webpack_public_path__ + "static/media/banner4v2.81f9bc29.png";